<template>
    <div class="container-page py-10 md:py-14">
        <SectionHeading title="Events" />

        <div class="card overflow-hidden">
            <div class="grid md:grid-cols-2">
                <div class="p-7 sm:p-10">
                    <span class="chip">Google Developer Student Clubs</span>
                    <h3 class="mt-5 font-display text-[26px] font-semibold leading-tight text-ink">GDSC Leads Summit</h3>
                    <div class="mt-5 space-y-4 text-[15.5px] leading-[1.75] text-ink-2">
                        <p>
                            I’ve come to the end of my Google Developer Student Clubs Lead position, which I have been
                            leading ATILIM University chapter for almost a year. I had an excellent year with meeting
                            various GDSC leaders from all around the world, learning a lot about both software
                            development and Google technologies, and of course, trying to introduce new technologies to
                            our Chapter members. Most of all, it was an excellent experience for me to be able to
                            develop my leadership experience in such a large community.
                        </p>
                        <p>
                            In this year, where we organized many events from different fields and technologies, the
                            efforts of the leaders I cooperated with and my core team are very valuable and meaningful
                            to me.
                        </p>
                    </div>
                </div>
                <div class="flex items-center bg-surface-2 p-5 sm:p-8">
                    <img src="/images/gdsc.webp" alt="GDSC Leads Summit" loading="lazy" decoding="async" width="2000"
                        height="1125" class="h-auto w-full rounded-2xl shadow-soft" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SectionHeading from '@/components/ui/SectionHeading.vue'

export default {
    components: { SectionHeading }
};
</script>
